import { createReducer } from 'helpers/redux';
import {
  SET_CONFIGURATIONS,
  SET_LOADED_CONFIGURATION,
  REMOVE_CONFIGURATION,
  CLEAR_LOADED_CONFIGURATION,
  SET_SAVING,
} from './types';

export const initialState = {
  configurations: [],
  loadedConfiguration: null,
  saving: false,
};

const garageReducer = createReducer({
  initialState,
  reducers: {
    [SET_CONFIGURATIONS]: (state, { payload: configurations }) => ({
      ...state,
      configurations,
    }),
    [SET_LOADED_CONFIGURATION]: (state, { payload: loadedConfiguration }) => ({
      ...state,
      loadedConfiguration,
    }),
    [REMOVE_CONFIGURATION]: (state, { payload: configurationId }) => ({
      ...state,
      configurations: state.configurations.filter(configuration => configuration.id !== configurationId),
    }),
    [CLEAR_LOADED_CONFIGURATION]: state => ({
      ...state,
      loadedConfiguration: null,
    }),
    [SET_SAVING]: (state, { payload: saving }) => ({
      ...state,
      saving,
    }),
  },
});

export default garageReducer;
